{
  "GENERAL": {
    "CLOSE": "Zavrieť",
    "SHOWING_RESULTS": "Zobrazuje sa {firstIndex}-{lastIndex} z {totalCount} položiek",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Hľadať",
      "EMPTY_STATE": "Žiadne výsledky neboli nájdené"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Vyžaduje sa aspoň {count}"
  }
}
